import React, { useEffect, useState } from 'react';
import { handleLoginRequest } from 'services/auth';
import history from 'utils/history';

import Loader from 'components/Informations/Loaders/PageLoader';

export default function Callback() {
  const [loaderVisibility, setLoaderVisibility] = useState(true);

  useEffect(() => {
    (async () => {
      const response = await handleLoginRequest();

      const { isAuthenticated } = response;

      if (isAuthenticated) {
        history.push('/auth/appointments');
      } else {
        history.push('/Login');
      }

      setLoaderVisibility(false);
    })();
  }, []);

  return <Loader isLoading={loaderVisibility} />;
}
